import { Directive, ElementRef, TemplateRef, ViewContainerRef, Input, OnInit } from '@angular/core';
import { Profile, User } from 'oidc-client';
import { CorizeEnvironment } from '../models/corize-environment';
import { BaseAuthService } from '../services/base-auth';

@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnInit {
  private permissions = [];
  private myPermissions :Profile;
  private logicalOp = 'AND';
  private currentUser: User;
  constructor(
    private element: ElementRef,
    private corize: CorizeEnvironment,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {

  }

  ngOnInit() {
    this.corize.currentUser.subscribe(user => {
      this.currentUser = user;
      this.updateView();
    });
  }

  @Input()
  set hasPermission(val) {
    this.permissions = val;
    this.updateView();
  }

  @Input()
  set hasPermissionOp(permop) {

    this.logicalOp = permop;
    this.updateView();
  }

  private updateView() {

    if (this.checkPermission()) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  private checkPermission() {
    let hasPermission = false;
    if (this.currentUser && this.permissions) {
      for (const checkPermission of this.permissions) {
        this.myPermissions = this.corize.getUser()?.profile;
        
        if (this.myPermissions != undefined)
        {
          var permissionFound = this.myPermissions[checkPermission] != undefined; 
          if (permissionFound) {
            hasPermission = true;
  
            if (this.logicalOp === 'OR') {
              break;
            }
          } else {
            hasPermission = false;
            if (this.logicalOp === 'AND') {
              break;
            }
          }
        }
        else{
          hasPermission = false;
        }
      }
    }
    return hasPermission;
  }
}